import { useCallback } from 'react';
import { useMutation, useQuery } from '@apollo/client';

import { InitSensitiveOperationDocument } from './graphql/mutations/initSensitiveOperation.gql';
import { VerifySensitiveOperationDocument } from './graphql/mutations/verifySensitiveOperation.gql';
import { SensitiveOperationPhoneDocument } from './graphql/queries/phoneNumber.gql';
import { Params } from './types';

const useSMSProtectedSensitiveOperation = ({
  actionData,
  actionType,
}: Params) => {
  const { data: phoneQueryData } = useQuery(SensitiveOperationPhoneDocument);

  const [initSensitiveOperationMutation, { data: initData }] = useMutation(
    InitSensitiveOperationDocument,
    {
      variables: {
        input: {
          actionData,
          actionType,
        },
      },
    },
  );

  const [verifySensitiveOperationMutation] = useMutation(
    VerifySensitiveOperationDocument,
  );

  const sensitiveOperationId =
    initData?.initSensitiveOperation.sensitiveOperation.sensitiveOperationId ||
    '';

  const phone = phoneQueryData?.viewer.profile.phone || '';

  const verifySensitiveOperationCode = useCallback(
    async (verificationCode: string): Promise<string> => {
      const { data, errors } = await verifySensitiveOperationMutation({
        variables: {
          input: {
            sensitiveOperationId,
            verificationCode,
          },
        },
      });

      if (errors !== undefined) {
        throw new Error(
          'Could not generate short lived token for sentitive operation, unknown error',
        );
      }

      if (data === undefined || data === null) {
        throw new Error(
          'Could not generate short lived token for sentitive operation, data is empty',
        );
      }

      const { token } = data.verifySensitiveOperation;

      return token;
    },
    [verifySensitiveOperationMutation, sensitiveOperationId],
  );

  return {
    initSensitiveOperation: initSensitiveOperationMutation,
    phone,
    verifySensitiveOperationCode,
  };
};

export default useSMSProtectedSensitiveOperation;
